import { defineStore } from 'pinia';

export interface DialogStateModel {
  componentName: string | null
  showDialog: boolean
  componentProps: any
  loader: boolean
}

export const useDialogStore = defineStore('dialogStore', {
  state: (): DialogStateModel => {
    return {
      componentName: null,
      componentProps: {},
      showDialog: false,
      loader: false,
    };
  },

  actions: {
    setLoader(value: boolean): void {
      this.loader = value;
    },
  },
});
